// extracted by mini-css-extract-plugin
module.exports = {"Nav":"Nav_Nav__cViw5","NavItem":"Nav_NavItem__3JjPk","NavItemActived":"Nav_NavItemActived__YLglo","name":"Nav_name__3xcQq"};